/**
 * Canonical dashboard page keys — must match vls-backoffice `app/rbac/dashboard_pages.py`
 * and human-agent `rbac_dashboard_matrix.py`.
 */

/** @type {readonly string[]} */
export const DASHBOARD_PAGE_KEYS = Object.freeze([
  "home",
  "chat",
  "tickets",
  "users",
  "analytics",
  "integrations",
  "widget_generator",
  "email_service",
  "docs_site",
  "settings",
]);

/** @type {Record<string, string>} */
export const DASHBOARD_PAGE_LABELS = {
  home: "Home",
  chat: "Inbox",
  tickets: "Tickets",
  users: "Users",
  analytics: "Analytics",
  integrations: "Integrations",
  widget_generator: "Widget generator",
  email_service: "Email service",
  docs_site: "Docs site",
  knowledge_base: "Knowledge Base",
  sentiment_analysis: "Sentiment Analysis",
  auto_qa: "AutoQA",
  settings: "Settings",
};

/** Route pathname (no basename) → page_key */
/** @type {Record<string, string>} */
export const PATHNAME_TO_PAGE_KEY = {
  "/": "home",
  "/chat": "chat",
  "/search": "chat",
  "/bot-chats": "chat",
  "/tickets": "tickets",
  "/users": "users",
  "/analytics": "analytics",
  "/integrations": "integrations",
  "/widget-generator": "widget_generator",
  "/email-service": "email_service",
  "/docs-site": "docs_site",
  "/settings": "settings",
};

/**
 * Routes that render a plan gate rather than an RBAC-governed page.
 *
 * Kept out of PATHNAME_TO_PAGE_KEY on purpose: that map drives the RBAC check
 * in ProtectedLayout, and these keys are not in the RBAC matrix, so including
 * them made every visit redirect to "/".
 *
 * @type {Record<string, string>}
 */
export const PATHNAME_TO_FEATURE_PAGE_KEY = {
  "/knowledge-base": "knowledge_base",
  "/sentiment": "sentiment_analysis",
  "/auto-qa": "auto_qa",
};

/**
 * @param {string} pathname
 * @returns {string | null}
 */
export function pageKeyForPathname(pathname) {
  const p = pathname.split("?")[0] || "/";
  if (PATHNAME_TO_PAGE_KEY[p]) return PATHNAME_TO_PAGE_KEY[p];
  return null;
}
